var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 53C6.73102 53 3.00006 49.269 3.00006 44.6667C3.00006 40.0643 6.73102 36.3333 11.3334 36.3333C15.9358 36.3333 19.6667 40.0643 19.6667 44.6667C19.6667 49.269 15.9358 53 11.3334 53Z",
    stroke: "white",
    strokeWidth: 4.26337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 19.6667C40.0643 19.6667 36.3333 15.9357 36.3333 11.3333C36.3333 6.73097 40.0643 3.00001 44.6667 3.00001C49.269 3.00001 53 6.73097 53 11.3333C53 15.9357 49.269 19.6667 44.6667 19.6667Z",
    stroke: "white",
    strokeWidth: 4.26337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6667 53V19.6667C44.6667 26.2971 42.0328 32.6559 37.3444 37.3443C32.656 42.0327 26.2971 44.6667 19.6667 44.6667",
    stroke: "white",
    strokeWidth: 4.26337,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.e0c8c77b07c9532b1ccf4e88b80bd3a0.svg";
export { ForwardRef as ReactComponent };